import { AppActions } from '../rootActions';
import { GET_FILTER_LIST } from './constants';

/**
 * Functions to be called in React components
 */

export const getFilterList = (): AppActions => ({ type: GET_FILTER_LIST });
